export enum OrderFlavor {
  PROD_DEBUG = 'prodDebug',
  PROD_RELEASE = 'prodRelease',
  DEV_DEBUG = 'devDebug',
}
